import React from 'react';
import { IoCloseSharp } from 'react-icons/io5';
import { useHistory, useLocation } from 'react-router';
import { PropsFromRedux } from '.';
import checkImg from '../../assets/images/pin-successful.svg';


interface Props extends PropsFromRedux {}



const WalletPinModal: React.FC<Props> = ({ hideModal, showModal, modal, getWalletPinStatus }) => {

  const history = useHistory();
  const location = useLocation();

  const closeModal = () => {
    getWalletPinStatus();
    hideModal();
    if (location.pathname.includes('withdraw')) {
      history.push('/cod-account');
    }
  }
  
  // <ModalWrapper hideCloseButton hideModal={hideModal}>
  return(
    <div className="w-full px-2 bg-white lg:px-20 py-10 relative">
        <button type="button" aria-label="Close" onClick={closeModal}>
         <IoCloseSharp className="sticky sm:absolute cursor-pointer text-2xl top-0 left-full sm:left-auto sm:right-5 sm:top-5" />
      </button>
    <div className="w-full my-2 flex items-center justify-center ">
      <img src={checkImg} alt="GIG App" className="w-28 my-4" />
    </div>
     <div className="w-full my-6 text-center">
         <h2 className="mb-1 text-lg font-medium text-black">Wallet pin successfully set.</h2>
      </div>
      <button className="w-full bg-secondary font-medium text-sm rounded text-white py-3" type="button" onClick={() => closeModal()}>Continue</button>

  </div>
  );
  // </ModalWrapper>
};

export default WalletPinModal;
